export default {
  priv: 'pr_manage',
  overviewTitle: 'Gebruikers',
  detailTitle: 'Gebruiker',
  deleteTitle: 'deze gebruiker',
  url: '/manage/users',
  apiUrl: '/users/',
  sortBy: ['username'],
  sortDesc: [false],
  deletable: false,
  editable: true,
  filterName: 'users',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'username',
    type: 'text'
  },
  newRecord: {
    is_active: true
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {
      text: 'Gebruikersnaam',
      value: 'username',
      link: '/manage/users/{id}',
      width: '10%'
    },
    {
      text: 'Display naam',
      value: 'full_name',
      width: '12.5%'
    },
    {
      text: 'Rol',
      value: 'userrole_name_nl',
      width: '7.5%'
    },
    {
      text: 'Email',
      value: 'email',
      width: '7.5%'
    },
    {
      text: 'Actief',
      value: 'is_active',
      type: 'boolean',
      width: '7.5%'
    }
    // {
    //   text: 'Aangemaakt op',
    //   value: 'created_date',
    //   width: '10%',
    //   filter: 'date'
    // },
    // {
    //   text: 'Laatste login',
    //   value: 'lastlogin_date',
    //   width: '10%',
    //   filter: 'date'
    // },
    // {
    //   text: 'Groep',
    //   value: 'userrole_name',
    //   width: '12.5%'
    // }
  ]
};
